import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingSpinner = ({ className = '' }) => {
  const { t } = useTranslation('common');

  return (
    <div className={`loading ${className}`.trim()} aria-busy="true">
      <div className="spinner" role="status" aria-label={t('loading')} />
    </div>
  );
};

export default LoadingSpinner;
